export namespace Storage {

    export class StorageController {

        /**
         * Save data to storage
         * @param name - storage item name
         * @param content - storage item content
         */
        public static saveToStorage(name: string, content: any): void {
            localStorage.setItem(name, JSON.stringify(content));
        }

        /**
         * Get data from storage
         * @param name - storage item name
         */
        public static getFromStorage(name: string): any {
            const data = localStorage.getItem(name);
            if (data === null) { return null; }
            return JSON.parse(data);
        }

        /**
         * Remove data from storage
         * @param name - storage item name
         */
        public static removeFromStorage(name: string): void {
            localStorage.removeItem(name);
        }
    }
}
